import { render, staticRenderFns } from "./MessageStatusTab.vue?vue&type=template&id=1a18d6ea&"
import script from "./MessageStatusTab.vue?vue&type=script&lang=js&"
export * from "./MessageStatusTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports